if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"empresas","remotes":[{"alias":"@selecta","name":"selecta","entry":"/company-selecta/remoteEntry.js","shareScope":"default"},{"alias":"@panel","name":"panel","entry":"/company-panel/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(34(07|16)|8(46(|0)|264|550)|1661|4207|6779|7000|9104)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}